// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
	production: false,
	isMockEnabled: true, // You have to switch this, when your real back-end is done
	authTokenKey: 'authce9d77b308c149d5992a80073637e4d5',
  //ApiRoot: 'http://localhost:8081/api',
	//ApiExport: 'http://localhost:3000/api',
	pageSize: [5, 10, 20, 50, 100],

	//Redirect Url test
	// redirectUrl: [
	// 	'http://localhost:4200',
	// 	'https://flow.jeeerp.com',
	// 	'https://nfc-hd.bookve.com.vn',
	// 	'https://nfc-scbt.bookve.com.vn'
	// ],

	//Redirect Url test live
	redirectUrl: [
		'http://localhost:4200',
		'https://flow.jeeerp.com',
		'https://nfc-hd.bookve.com.vn',
		'https://nfc-scbt.bookve.com.vn'
	],

	// Api-DEV
	// ApiRoot:'https://nfc-apidev.bookve.com.vn/api',

	//Api-TEST
	//ApiRoot: 'https://nfc-test-api.jeeerp.com/api',
	//ApiExport: 'https://export-api.jee.vn/api',

	//Api-LIVE
	ApiRoot: 'https://nfc-api.jeeerp.com/api',
	ApiExport: 'https://export-live-api.jeeerp.com/api',

	// Menu config
	nfc_jeeerp: [1, 2, 3, 4, 5, 6, 7, 8, 10, 11, 12, 15],
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
